export const GET_INVENTORY_DATA = 'GET_INVENTORY_DATA'